import * as React from "react";
const SvgCarretDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 4, viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.99996 3.66699L7.33329 0.333659L0.666626 0.333659L3.99996 3.66699Z", fill: "#182736" }));
export default SvgCarretDown;
